import EventEmitter from "eventemitter3";

type EventTopics =
  | "NOTIFICATION"
  | "OPEN_SUBSCRIPTION_MODAL"
  | "PUSH_NEW_MESSAGE"
  | "REPORT_SECTION_CHANGED"
  | "REPORT_SCROLL_TO_SECTION"
  | "REPORT_TOGGLE_SECTION"
  | "REPORT_ENABLED_SECTIONS"
  // The page emits OUTLINE so the sidebar can render the full structure
  // (sections + their subsection list). Shape mirrors what a future
  // GET /report/outline endpoint will return — sections with their numbers,
  // titles, and nested blocks — so swapping the source later is just a
  // matter of where the event fires from. ENABLED_BLOCKS / TOGGLE_BLOCK /
  // SCROLL_TO_BLOCK mirror the section-level events at the block granularity.
  | "REPORT_OUTLINE"
  // Case-level header info for the sidebar (tier, property title, address) —
  // fired alongside REPORT_OUTLINE from the same page, so the sidebar can
  // show its "level / title / address" block without fetching the case itself.
  | "REPORT_CASE_META"
  | "REPORT_ENABLED_BLOCKS"
  | "REPORT_TOGGLE_BLOCK"
  | "REPORT_SCROLL_TO_BLOCK"
  | "REPORT_SECTION_RENDER_ERROR"
  // Fired when the chat's fill_contract_variables tool saves data on a
  // contract, so a ContractDetails page already open (e.g. behind the
  // mini-chat) can refetch and show the new values without a reload.
  | "CONTRACT_VARIABLES_UPDATED"
  | "OPEN_USER_MENU"
  | "CLOSE_USER_MENU";

export const eventBus = new EventEmitter<EventTopics>();
